// extracted by mini-css-extract-plugin
export default {"topbar":"style_topbar__KDAYJ","logo":"style_logo__yPjGs"};